import { configureStore } from '@reduxjs/toolkit';
import artworkSlice from './slices/artworks';
import authSlice from './slices/auth';
import filesSlice from './slices/files';
import marketplaceManagementSlice from './slices/marketplace-management';
import marketplaceSlice from './slices/marketplace';
import organizationSlice from './slices/organization';
import propertiesSlice from './slices/properties';
import reconciliationSlice from './slices/reconciliation';

export default configureStore({
  reducer: {
    artworks: artworkSlice,
    auth: authSlice,
    files: filesSlice,
    marketplace: marketplaceSlice,
    marketplaceManagement: marketplaceManagementSlice,
    organization: organizationSlice,
    properties: propertiesSlice,
    reconciliation: reconciliationSlice,
  },
});
